import { ChecklistTemplateBuilderEditable } from '@/ui/DTO/checklistTemplateBuilderEditable';

export interface InspectionActionLegacy {
  uuid: string;
  type: 'action';
  action: 'inspection';
  executed_at: string | null;
  params: {
    checklist_id: number | null;
    title: string;
    due_in: ChecklistTemplateBuilderEditable['dueIn']['value'];
    assignees: {
      users: Array<string>;
      groups: Array<string>;
    };
    associateAssignees: Array<string>;
  };
}

export const emptyInspectionActionLegacy = (): InspectionActionLegacy => ({
  uuid: '',
  type: 'action',
  action: 'inspection',
  executed_at: null,
  params: {
    checklist_id: null,
    title: '',
    due_in: { weeks: null, days: null, hours: null, minutes: null },
    assignees: {
      users: [],
      groups: [],
    },
    associateAssignees: [],
  },
});

export const jsonInspectionActionToChecklistTemplateEditableAdaptor = (inspectionActionLegacy: InspectionActionLegacy): ChecklistTemplateBuilderEditable => {
  return {
    checklistId: {
      value: inspectionActionLegacy.params.checklist_id,
    },
    title: {
      value: '',
    },
    assignees: {
      value: inspectionActionLegacy.params.assignees.users.map(user => `user_${user}`),
    },
    associateAssignees: {
      value: inspectionActionLegacy.params.associateAssignees,
    },
    dueIn: {
      value: inspectionActionLegacy.params.due_in,
    },
    assignedGroups: {
      value: inspectionActionLegacy.params.assignees.groups.map(group => `group_${group}`),
    },
  };
};
